import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import {
  ClientSurveyModel,
  ClientSurveyVersionModel,
} from '../../../api/models';
import { AccountInfoService } from '../../../services/account-info.service';
import { BaseAccountInfoComponent } from '../../BaseAccountInfo/BaseAccountInfo.component';
import { TakeSurveyModalComponent } from '../../modals/take-survey-modal/take-survey-modal.component';

@Component({
  selector: 'app-survey-version-grid',
  templateUrl: './survey-version-grid.component.html',
  styleUrls: ['./survey-version-grid.component.scss'],
})
export class SurveyVersionGridComponent
  extends BaseAccountInfoComponent
  implements OnInit
{
  @Input() survey: ClientSurveyModel;
  @Input() surveyVersions: ClientSurveyVersionModel[] | null | undefined = [];

  @Output() reloadParent2: EventEmitter<boolean> = new EventEmitter<boolean>();

  @ViewChild(TakeSurveyModalComponent)
  TakeSurveyModalChild!: TakeSurveyModalComponent;

  areSurveyVersionsLoading = true;

  faCircleNotch = faCircleNotch;

  constructor(protected override accountInfoService: AccountInfoService) {
    super(accountInfoService);
  }

  override ngOnInit() {
    super.ngOnInit();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['surveyVersions']) {
      if (this.surveyVersions !== null) {
        this.surveyVersions = this.surveyVersions?.reverse();
        this.areSurveyVersionsLoading = false;
      }
    }
  }

  reloadSurveyDetails() {
    this.reloadParent2.emit(true); // Notify the parent so they can reload data.
  }

  doesSurveyNeedApproval(m: ClientSurveyVersionModel) {
    if (m.isDraft) return true;

    return false;
  }
}
